import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentInit,
  AfterViewInit,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import $ from 'jquery';
import { CodeService, AuthService, BUYER_ROLE, BUYER_STATUS } from '../../../shared';
import { Tree } from '../../../../app/common/libs';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  PopularSearch,
  SearchDto,
  DisplayCategory,
  HomeDto,
  NoticeBoard,
  NoticeBoardListDto,
  Buyer,
} from '../../../dto';
import { SearchService, HomeService, ProductService, BuyerService } from '../../../services';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized, NavigationExtras } from '@angular/router';
import { BaseUser } from '../../../shared/auth/dto/base-user';
import { BaseComponent } from '../../../core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { debounceTime, distinctUntilChanged, filter, pairwise, takeWhile } from 'rxjs/operators';
import dayjs from 'dayjs';
import Swiper from 'swiper';
import { UDirectService } from 'src/app/services/udirect.service';
// import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
// import { CookieService } from 'ngx-cookie';
export {};
declare global {
  interface Window {
    Calendly: any;
  }
}

enum HEADER {
  AUTHORIZED = 'AUTHORIZED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NONE = 'none',
}

enum FOOTER {
  AUTHORIZED = 'AUTHORIZED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NONE = 'none',
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent extends BaseComponent implements OnInit, AfterViewInit {
  static UNAUTHORIZED_LAYOUT = {
    header: HEADER.UNAUTHORIZED,
    footer: FOOTER.UNAUTHORIZED,
  };

  static AUTHORIZED_LAYOUT = {
    header: HEADER.AUTHORIZED,
    footer: FOOTER.AUTHORIZED,
  };

  static AUTHORIZED_WITHOUT_FOOTER_LAYOUT = {
    header: HEADER.AUTHORIZED,
    footer: FOOTER.NONE,
  };

  SEARCH_TYPE = Object.freeze({
    BRAND: 'BRAND',
    PRODUCT: 'PRODUCT',
    SEARCH: 'SEARCH',
  });

  SEARCH_URL = '/search?q=';

  lang = this.LANGUAGES[0];
  // googleLanguage = this.GOOGLE_LANGUAGES[0];

  isNotChrome = false;
  noticeBoards: NoticeBoard[] = [];

  displayCategory: DisplayCategory[];
  displayCategoryTree: Tree<DisplayCategory>;
  searchForm: FormGroup;
  recentSearches: Array<string> = [];
  popularSearches: PopularSearch[];
  isSearchingLists: SearchDto[];
  brandsType: SearchDto[] = [];
  productType: SearchDto[] = [];
  isSearching = false;
  defaultSearch = false;
  user: BaseUser;
  isDisableNext = false; // true: 비활성화, false: 활성화
  isDisablePrev = true; // true: 비활성화, false: 활성화

  header: HEADER = LayoutComponent.UNAUTHORIZED_LAYOUT.header;
  footer: FOOTER = LayoutComponent.UNAUTHORIZED_LAYOUT.footer;

  visualNoticeConfig: Swiper;

  @ViewChild('Keyword', { read: ElementRef, static: false })
  Keyword: ElementRef;
  @ViewChild('authorizedHeaderTop', { read: ElementRef, static: false })
  authorizedHeaderTop: ElementRef;
  @ViewChild('headerRef', { read: ElementRef, static: false })
  headerRef: ElementRef;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.header === 'UNAUTHORIZED') {
      return;
    }

    this.headerRef.nativeElement.classList.add('active');
    // const headerOffset = this.authorizedHeaderTop.nativeElement.offsetHeight;
    // if (window.pageYOffset >= headerOffset) {
    //   // $('header').addClass('active');
    //   this.headerRef.nativeElement.classList.add('active');
    // } else {
    //   // $('header').removeClass('active');
    //   this.headerRef.nativeElement.classList.remove('active');
    // }
  }

  constructor(
    private el: ElementRef,
    private codeService: CodeService,
    private formBuilder: FormBuilder,
    private searchService: SearchService,
    private homeService: HomeService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    // private cookieService: CookieService
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
    public uDirectService: UDirectService
  ) {
    super();
  }

  ngOnInit() {
    // window.Calendly.initBadgeWidget({
    //   url: 'https://calendly.com/umma_craver',
    //   text: 'schedule a meeting',
    //   color: '#f23da6',
    //   textColor: '#ffffff',
    //   branding: false,
    // });
    // let t: any = document.querySelectorAll('.calendly-badge-widget')[0];
    // if (this.userDeviceInfo === 'pc') {
    //   t.classList.add('pc');
    // } else {
    //   t.classList.remove('pc');
    // }
    this.searchForm = this.formBuilder.group({
      keyword: [''],
    });

    this.router.events.pipe(takeWhile(() => this.isAlive)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.startsWith(this.SEARCH_URL)) {
          this.searchForm.get('keyword').setValue(decodeURIComponent(this.router.url.replace(this.SEARCH_URL, '')));
        }
      }
    });

    this.route.data.pipe(takeWhile(() => this.isAlive)).subscribe((data) => {
      this.user = this.authService.getUser();
      if (this.user && this.user.buyerStatus.includes(BUYER_STATUS.DORMANT)) {
        this.router.navigate(['/signin/dormant']);
      }
      // if (this.user && !this.user.isCertified) {
      //   this.router.navigate(['/signin/mobile-otp']);
      // }
      if (this.user && this.user.buyerStatus.includes(BUYER_STATUS.WAITING)) {
        this.router.navigate(['/signin/waiting']);
      }

      if (
        this.user &&
        (this.user.buyerStatus.includes(BUYER_STATUS.REFUSED) || this.user.buyerStatus.includes(BUYER_STATUS.REREQUEST))
      ) {
        this.router.navigate(['/my/account']);
      }
      if (this.user && this.user.userRoles.includes(BUYER_ROLE.BUYER_APPROVED) && data.layout) {
        this.homeService.getNotice(this.i18n.language).subscribe((NoticeBoards) => {
          this.noticeBoards = NoticeBoards;
          this.cdr.detectChanges();
          this.visualNoticeConfig = new Swiper('.visualNoticeConfig', {
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
            },
            loop: true,
            direction: 'vertical',
            threshold: 2,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
              nextEl: '.button-next-notice',
              prevEl: '.button-prev-notice',
            },
          });
        });
        this.header = data.layout.header || this.header;
        this.footer = data.layout.footer || this.footer;
      }
    });
    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        const previousUrl = e[0].urlAfterRedirects;
        if (previousUrl.indexOf('/withdraw') === 0) {
          console.log('previousUrl', previousUrl);
          console.log('previousUrl.indexOf', previousUrl.indexOf('/withdraw'));
          this.router.navigate(['/withdraw']);
        }
        // if (
        //   this.user &&
        //   (!previousUrl || previousUrl.indexOf('/withdraw') < 0) &&
        //   (this.user.buyerStatus.includes(BUYER_STATUS.REFUSED) ||
        //     this.user.buyerStatus.includes(BUYER_STATUS.REREQUEST))
        // ) {
        //   this.router.navigate(['/my/account']);
        // }
      });
    this.LANGUAGES.forEach((lang) => {
      if (lang.locale === this.i18n.language) {
        this.lang = lang;
      }
    });

    // this.GOOGLE_LANGUAGES.forEach((lang) => {
    //   const cookieKey = this.cookieService.getObject('googtrans') ? this.cookieService.get('googtrans').split('/')[2] : '';
    //   if (lang.locale === cookieKey) {
    //     this.googleLanguage = lang;
    //   }
    // });

    this.displayCategory = this.homeService.getMainDisplayCategory();

    localStorage.getItem('search')
      ? (this.recentSearches = JSON.parse(localStorage.getItem('search')))
      : localStorage.setItem('search', JSON.stringify([]));

    this.searchForm
      .get('keyword')
      .valueChanges.pipe(takeWhile(() => this.isAlive))
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((keyword) => {
        this.isSearching = (keyword && keyword !== '') || (keyword && keyword.length > 2);
        if (keyword) {
          this.searchService.getSearch(keyword).subscribe((searchDto) => {
            this.isSearchingLists = searchDto;

            this.brandsType = this.isSearchingLists.filter((list) => list.searchType.includes('BRAND'));
            this.productType = this.isSearchingLists.filter((list) => list.searchType.includes('PRODUCT'));

            this.sendKeywordToGA(keyword, this.brandsType, this.productType);
          });
        } else {
          this.brandsType = [];
          this.productType = [];
        }
      });

    this.searchService.getPopularSearch().subscribe((popularSearches) => {
      this.popularSearches = popularSearches;
    });

    this.displayCategoryTree = this.codeService.getDisplayCategoryAsTree();
    this.unsupportedFunction();
  }

  // ngAfterContentInit() {
  //   this.ui_actions();
  // }

  ngAfterViewInit() {
    this.ui_actions();
  }

  goCategory(categoryId: number) {
    this.router.navigate(['/category', categoryId], { queryParams: { categoryId } });
  }

  onSearch(header?: HTMLElement, searchLabel?: HTMLElement) {
    // small search 돋보기 선택일시 검색안하고 toggle
    if (header && header.classList.contains('active') && !searchLabel.classList.contains('active')) {
      return searchLabel.classList.toggle('active');
    }

    const keyword = this.searchForm.get('keyword').value;
    const isInclude = this.recentSearches.includes(keyword);
    if (keyword) {
      this.router.navigate([`/search`], { queryParams: { q: keyword } });

      this.defaultSearch = false;
      this.isSearching = false;
      if (this.recentSearches.length < 10 && !isInclude) {
        this.recentSearches.unshift(keyword);
      } else if (!isInclude) {
        this.recentSearches.pop();
        this.recentSearches.unshift(keyword);
      }
      localStorage.setItem('search', JSON.stringify(this.recentSearches));
    } else {
      const dialog = this._openDialog({
        message: this.i18n.t('DIALOG.SEARCH.REQUIRED'),
        close: () => {
          dialog.close();
        },
      });
    }

    this.Keyword.nativeElement.blur();
  }

  openDefaultSearch() {
    this.defaultSearch = true;
    this.gtmService.pushTag({
      event: 'gaEvent',
      category: 'search',
      action: 'open search bar',
      label: 'open search bar',
    });
  }

  onClickKeyword(searchType: string, keyword: number | string, isTrend?: boolean) {
    this.defaultSearch = false;
    this.isSearching = false;
    switch (searchType) {
      case this.SEARCH_TYPE.BRAND:
        this.searchForm.get('keyword').setValue('');
        this.router.navigate([`/brand`, keyword], { queryParams: { brandId: keyword } });
        break;
      case this.SEARCH_TYPE.PRODUCT:
        this.searchForm.get('keyword').setValue('');
        this.router.navigate([`/product`, keyword], {
          queryParams: { productId: keyword },
          state: { dataList: 'Preview Product' },
        });
        break;
      case this.SEARCH_TYPE.SEARCH:
        this.router.navigate([`/search`], { queryParams: { q: keyword } });
        if (isTrend) {
          this.gtmService.pushTag({
            event: 'gaEvent',
            category: 'search',
            action: 'Click Search Trend Keyword',
            label: `Click Search Trend Keyword : ${keyword}`,
          });
        }
        break;
    }
  }

  onRemoveItems(event: Event, i: number) {
    this.recentSearches.splice(i, 1);
    localStorage.setItem('search', JSON.stringify(this.recentSearches));
  }

  clearAllItems() {
    const dialog = this._openDialog({
      message: this.i18n.t('DIALOG.SEARCH.DELETE'),
      close: () => {
        localStorage.removeItem('search');
        this.recentSearches = [];
        dialog.close();
      },
      cancel: () => {
        dialog.close();
      },
    });
  }

  sendKeywordToGA(keyword: string, brandsType: SearchDto[], productType: SearchDto[]) {
    let action: string;
    if (brandsType.length === 0 && productType.length === 0) {
      action = 'brand-product-not-found';
    } else if (brandsType.length !== 0 && productType.length === 0) {
      action = 'brand-only-found';
    } else if (brandsType.length === 0 && productType.length !== 0) {
      action = 'product-only-found';
    } else {
      action = 'brand-product-found';
    }

    this.gtmService.pushTag({
      event: 'gaEvent',
      category: 'search-result',
      action,
      label: keyword,
    });
  }

  private ui_actions() {
    // tslint:disable-next-line: deprecation
    $(document).ready(() => {
      gnbAction();
    });
    const gnbAction = () => {
      const gnb = $('.gnb-link > ul');
      const snb = $('.group-snb');
      let idx;
      // tslint:disable-next-line: prefer-const
      let timeout;
      let clicked = false;

      // function _snbhide(t) {
      //   if (t !== 'click') {
      //     clearTimeout(timeout);
      //     timeout = setTimeout(function () {
      //       snb.hide();
      //       snb.find('.group-snb-list').hide();
      //       gnb.find('li').removeClass('active');
      //     }, 100);
      //   } else {
      //     snb.hide();
      //     snb.find('.group-snb-list').hide();
      //     clicked = true;
      //   }
      // }

      gnb.find('li').on('mouseout', function (e) {
        if (clicked === true && $(this).hasClass('active')) {
          setTimeout(() => {
            clicked = false;
          }, 100);
        }
      });
      gnb.find('li').on('mouseover', function (e) {
        if (clicked === true && $(this).hasClass('active')) {
          return;
        } else {
          clicked = false;
        }
        if ($(this).index() >= 0) {
          idx = $(this).index();
        }

        clearTimeout(timeout);
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        snb.find('.group-snb-list').hide();
        if (idx >= 0) {
          snb.find('.group-snb-list').eq(idx).show();
        }
      });

      // tslint:disable-next-line: deprecation
      $('.gnb-link > ul, .group-snb').mouseenter(() => {
        clearTimeout(timeout);
        snb.show();
        $('.dim').show();
      });
      // tslint:disable-next-line: deprecation
      $('.gnb-link > ul, .group-snb').mouseleave(() => {
        clearTimeout(timeout);
        $('.gnb-link > ul li').removeClass('active');
        $('.group-snb').hide();
        $('.dim').hide();
      });
      // tslint:disable-next-line: deprecation
      $('.gnb-link > ul, .group-snb a').click(() => {
        clearTimeout(timeout);
        $('.gnb-link > ul li').removeClass('active');
        $('.group-snb').hide();
        $('.dim').hide();
      });
    };
    // const headerOffset = $('header').offset();

    // $(window).scroll(function () {
    //   if ($(document).scrollTop() > headerOffset.top) {
    //     $('header').addClass('active');
    //   } else {
    //     $('header').removeClass('active');
    //   }
    // });
  }

  unsupportedFunction() {
    if (this.deviceDetector.browser !== 'Chrome') {
      this.isNotChrome = true;
    }
  }

  // onChangeGoogleLanguage(lang: string) {
  //   const dialog = this._openDialog({
  //     message:
  //       'There may be a problem with order payment when changing the language. Please check, change it to English, and proceed again.',
  //     close: () => {
  //       this.GOOGLE_LANGUAGES.forEach((language) => {
  //         if (language.locale === lang) {
  //           this.googleLanguage = language;
  //         }
  //       });
  //       const expiredDate = dayjs().add(7, 'day').toDate();
  //       this.cookieService.put('googtrans', `/en/${lang}`, { expires: expiredDate });
  //       document.location.reload();
  //       dialog.close();
  //     },
  //     cancel: () => {
  //       document.location.reload();
  //       dialog.close();
  //     },
  //   });
  // }

  downloadExcel() {
    this.productService.downloadInventoryExcel();
  }
  goPage(page, i) {
    if (this.noticeBoards[i].noticeCategory === 'APP') {
      window.open(this.noticeBoards[i].content.split('|')[1], '_blank');
    } else {
      this.router.navigate([page]);
    }
  }
}
